import React, { useEffect, useState } from 'react';
import { Drawer } from '@material-ui/core';
import { FooterType } from 'configuration-schemas/general';
import styles from 'src/pages/NavigationShell/NavigationShell.styles';
import { values } from 'lodash';
import { PivotInsights } from 'src/components/PivotInsights/PivotInsights';
import { PivotInsightData, PivotInsightConfig } from 'src/pages/NavigationShell/Footer/Footer.types';
import container from 'src/ServiceContainer';
import { ClientDataApi } from 'configuration-schemas/confdefnView';
import { FooterTypeConfigs, FooterTypeRecord } from 'configuration-schemas/confdefn';

interface FooterDrawerProps {
  activeFooterType: FooterTypeConfigs;
  footerTypes: FooterTypeRecord;
  open: boolean;
  onClose: () => void;
}

export function showFooterType(footerTypes: FooterTypeRecord, footerType: FooterType): boolean {
  return values(footerTypes).some((config) => config.footerType === footerType);
}

export function FooterDrawer({ activeFooterType, footerTypes, open, onClose }: FooterDrawerProps) {
  const [config, setConfig] = useState<PivotInsightConfig | null>(null);
  const [data, setData] = useState<PivotInsightData[]>([]);

  useEffect(() => {
    if (activeFooterType.footerType !== FooterType.none) {
      container.tenantConfigClient
        .getTenantViewDefns({
          defnIds: [activeFooterType.configApi.params.defnId!],
          appName: activeFooterType.configApi.params.appName,
        })
        .then((resp) => {
          setConfig(resp[0] as unknown as PivotInsightConfig);

          const dataApi = activeFooterType.dataApi as ClientDataApi;

          return container.pivotService.listData(dataApi.params!.defnId).then((resp) => {
            setData(resp.flat as unknown as PivotInsightData[]);
          });
        })
        .catch((error) => {
          console.error('Error fetching footer config:', error);
        });
    }
  }, [activeFooterType]);

  let content = null;

  switch (activeFooterType?.footerType) {
    case FooterType.insights:
      const showInsights = showFooterType(footerTypes, FooterType.insights);
      if (showInsights) {
        content = <PivotInsights data={data} config={config} onClose={onClose} />;
      } else {
        console.warn(`Unable to load ${FooterType.insights}, no configuration found`);
      }
      break;
  }

  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={open}
      onClose={onClose}
      classes={{
        paperAnchorBottom: styles.footerInsightsContainer,
      }}
    >
      {content}
    </Drawer>
  );
}
